import React from 'react';
import ReportCardComponent from '../../../components/Cards/Report';

const ReportCard = () => <ReportCardComponent></ReportCardComponent>;

export default ReportCard;
